import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "rycm_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1, size = "", color = "") => {
    setItems((cur) => {
      const key = `${product.id}-${size}-${color}-${product.participant_name || ""}`;
      const existing = cur.find((i) => `${i.product_id}-${i.size}-${i.color}-${i.participant_name || ""}` === key);
      if (existing) {
        return cur.map((i) =>
          `${i.product_id}-${i.size}-${i.color}-${i.participant_name || ""}` === key ? { ...i, quantity: i.quantity + qty } : i
        );
      }
      return [
        ...cur,
        {
          product_id: product.id,
          name: product.name,
          unit_price: product.price,
          image: product.image,
          quantity: qty,
          size,
          color,
          type: product.type || "physical",
          participant_name: product.participant_name || "",
          participant_notes: product.participant_notes || "",
          // Extended stage-booking fields (RYCM iter 21)
          participant_first_name: product.participant_first_name || "",
          participant_last_name: product.participant_last_name || "",
          participant_birthdate: product.participant_birthdate || "",
          participant_email: product.participant_email || "",
          participant_phone: product.participant_phone || "",
          participant_address: product.participant_address || "",
          participant_weight: product.participant_weight || "",
          participant_height: product.participant_height || "",
          participant_boat: product.participant_boat || "",
          participant_experience: product.participant_experience || "",
        },
      ];
    });
  };

  const updateQty = (key, qty) => {
    if (qty <= 0) {
      setItems((cur) => cur.filter((i) => `${i.product_id}-${i.size}-${i.color}-${i.participant_name || ""}` !== key));
    } else {
      setItems((cur) =>
        cur.map((i) =>
          `${i.product_id}-${i.size}-${i.color}-${i.participant_name || ""}` === key ? { ...i, quantity: qty } : i
        )
      );
    }
  };

  const removeItem = (key) => {
    setItems((cur) => cur.filter((i) => `${i.product_id}-${i.size}-${i.color}-${i.participant_name || ""}` !== key));
  };

  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
